// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2zi8n","errorLogs":"styles_errorLogs__1fWCw"};